<template>
  <svg
    class="checkmark-animation transform-gpu"
    fill="none"
    stroke-width="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    ></path>
  </svg>
</template>

<style lang="scss" scoped>
.checkmark-animation {
  animation: checkmark-animation 240ms cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes checkmark-animation {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.4);
  }

  100% {
    transform: scale(1);
  }
}
</style>
